class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      // location.reload();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);      
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      
      let cart = $.getJSON('/cart.js'); 
      cart.done(function(){
        
        cart = cart.responseJSON;
        
        if(cart.total_price == 0){
          $('.profit-wrapper,.cart-product-wrapper').hide();
        }
        
        if(cart.total_price < 5000){
          $('.cart-product-wrapper').addClass('disable_product');
          $('.free-product').each(function(){
            $(this).find('cart-remove-button').trigger('click');
            return false;
          });
        }else{
          $('.cart-product-wrapper').removeClass('disable_product');
        }
        
        $('.free-product').each(function(){
          $(this).find('.cart-item__quantity input').prop('readonly', true);
        });
        
        var ItemCount = $('.free-product').length;      
        if(ItemCount == "2"){
          $('.cart-product-wrapper').addClass('disable_product');
          $('.free-product').each(function(){
            $(this).find('.quantity__button[name="plus"]').css('pointer-events','none')
          });
        }
        
        var FreeProductQuantity =  $('.free-product .quantity__input').val();
        if(FreeProductQuantity >= "2"){
          $('.cart-product-wrapper').addClass('disable_product');
          if(FreeProductQuantity >= "2"){
            $('.free-product').each(function(){
              $(this).find('.quantity__button[name="plus"]').css('pointer-events','none')
            });
          }
        }
        
        let first_product_clicked = false;
        let second_product_clicked = false;
        let first_productPrice = $('.free-product-price.first_product').text();
        let second_productPrice = $('.free-product-price.second_product').text();
        let cartTotal = cart.total_price;
        let first_freeLength = $('.cart-item.gift-product.first_product').length;
        let second_freeLength = $('.cart-item.gift-product.second_product').length;
        var first_giftPrice = '';
        var second_giftPrice = '';
        
        if(first_freeLength >= 1){
          first_giftPrice = cartTotal - first_productPrice;
        }else{
          first_giftPrice = cart.total_price;
        }

        if(second_freeLength >= 1){
          second_giftPrice = cartTotal - second_productPrice;
        }else{
          second_giftPrice = cart.total_price;
        }

        

        

          
        
      });
      
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);